<template>
  <a-table :columns="columns" :dataSource="data" bordered>
    <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            style="padding: 8px"
    >
      <a-input
              v-ant-ref="c => searchInput = c"
              :placeholder="`Search ${column.dataIndex}`"
              :value="selectedKeys[0]"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm)"
              style="width: 188px; margin-bottom: 8px; display: block;"
      />
      <a-button
              type="primary"
              @click="() => handleSearch(selectedKeys, confirm)"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
      >搜索</a-button
      >
      <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px"
      >重置</a-button
      >
    </div>
    <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
    />



    <template
            v-for="col in ['name', 'age']"
            :slot="col"
            slot-scope="text, record, index"
    >
      <div :key="col">
        <a-input
                v-if="record.editable"
                style="margin: -5px 0"
                :value="text"
                @change="e => handleChange(e.target.value, record.key, col)"
        />
        <template v-else
        >{{text}}</template
        >
      </div>
    </template>
    <template slot="operation" slot-scope="text, record">
      <a @click="() => edit(record.key)">审核</a>
      
    </template>
  </a-table>
</template>
<script>
  import request from "../../utils/request";
  const columns = [
      {
          title: '操作',
          width: '10%',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
      },
    {
      title: '姓名',
      dataIndex: 'name',
      width: '20%',
      scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
        customRender: 'customRender',
      },
      onFilter: (value, record) => record.name.toString().toLowerCase().includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => {
            this.searchInput.focus();
          }, 0);
        }
      },
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      width: '20%',
      scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
        customRender: 'customRender',
      },
      onFilter: (value, record) => record.phone.toString().toLowerCase().includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => {
            this.searchInput.focus();
          }, 0);
        }
      },
    },
    {
      title: '身份证',
      dataIndex: 'id_code',
      width: '10%',
    },
    {
      title: '用户状态',
      dataIndex: 'is_delete_text',
      width: '10%',
    },
    {
      title: '申请时间',
      dataIndex: 'real_name_time',
      width: '10%',
    },

  ];

  export default {
    data() {
      return {
        data:[],
        columns,
        searchText: '',
        searchInput: null,
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData(){
          // request({
          //     url: "https://lot.handsomemark.com/mark/",
          //     method: "post",
          //     params: {}
          // }).then(response => {
          //     console.log("测试",response);
          // });

        request({
          url: "/user/all/need/real_name",
          method: "get",
          params: {}
        }).then(response => {
          console.log("获取到的参数",response.data.data);
          if(response.data.success){
          this.data=response.data.data;
          }else{
              this.$message.error(response.data.msg)
          }
        });
      },
      handleSearch(selectedKeys, confirm) {
        confirm();
        this.searchText = selectedKeys[0];
      },

      handleReset(clearFilters) {
        clearFilters();
        this.searchText = '';
      },
      onDelete(key) {
        request({
          url: "/user/"+key+"/",
          method: "delete",
          params: {}
        }).then(response => {
          console.log("111");
          if(response.data.success){
          this.getData();
          }else{
            this.$message.error(response.data.msg);
          }
        });
      },
      getBack(key) {
        request({
          url: "/user/getback/"+key,
          method: "put",
          params: {}
        }).then(response => {
          this.getData();
        });
      },
      handleChange(value, key, column) {
        const newData = [...this.data];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target[column] = value;
          this.data = newData;
        }
      },
      edit(key) {
        this.$router.push({path: '/user/manager/real_name_detail', query: {the_id: key}})
      },
      save(key) {
        const newData = [...this.data];
        const newCacheData = [...this.cacheData];
        const target = newData.filter(item => key === item.key)[0];
        const targetCache = newCacheData.filter(item => key === item.key)[0];
        if (target && targetCache) {
          delete target.editable;
          this.data = newData;
          Object.assign(
                  targetCache,
                  target
          );
          this.cacheData = newCacheData;
        }
      },
      cancel(key) {
        const newData = [...this.data];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          Object.assign(target, this.cacheData.filter(item => key === item.key)[0]);
          delete target.editable;
          this.data = newData;
        }
      },
    },
  };
</script>
<style scoped>
  .editable-row-operations a {
    margin-right: 8px;
  }
</style>